import { useTranslation } from 'react-i18next';

const useTranslate = (scope?: string) => {
	const { t } = useTranslation();

	return (value: string) => t(`${scope}:${value}`) as string;
};

export default useTranslate;
